import config from "@/config"
import http from "@/utils/request"
export default {
  deliveryOrder: {
    manage: {
      url: `${config.API_URL}/delivery`,
      name: "获取快递订单列表",
      get: async function (params) {
        return await http.get(`${this.url}/manage/deliveryOrder/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/checkDemand`, data)
      },
      viewDeliveryInfo: async function (data) {
        return await http.post(`${this.url}/manage/deliveryOrder/viewDeliveryInfo`, data) //快递信息查看
      },
      getOperates: async function (params) {
        return await http.get(`${config.API_URL}/demandOperate/manage/getOperationsById`, params)
      }
    }
  },
  deliveryThird: {
    manage: {
      url: `${config.API_URL}/delivery/manage`,
      name: "获取快递三方主体列表",
      get: async function (params) {
        return await http.get(`${this.url}/thirdDelivery/list`, params)
      },

      submit: async function (data) {
        return await http.post(`${this.url}/thirdDelivery/create`, data) //对需求单进行审核
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      getOperates: async function (params) {
        return await http.get(`${config.API_URL}/demandOperate/manage/getOperationsById`, params)
      }
    }
  },
  deliveryType: {
    manage: {
      url: `${config.API_URL}/delivery/manage`,
      name: "获取快递类型列表",
      get: async function (params) {
        return await http.get(`${this.url}/deliveryType/list`, params)
      },
      changeProfit: async function (data) {
        return await http.post(`${this.url}/deliveryType/changeProfit`, data) //设置盈利方式
      },
      close: async function (data) {
        return await http.post(`${this.url}/deliveryType/close`, data) //设置启用
      },
      submit: async function (data) {
        return await http.post(`${this.url}/deliveryType/create`, data) //创建
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      getOperates: async function (params) {
        return await http.get(`${config.API_URL}/demandOperate/manage/getOperationsById`, params)
      }
    }
  },
  deliveryBusiness: {
    manage: {
      url: `${config.API_URL}/delivery/manage`,
      name: "获取快递业务列表",
      get: async function (params) {
        return await http.get(`${this.url}/deliveryBusiness/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/deliveryBusiness/create`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      getOperates: async function (params) {
        return await http.get(`${config.API_URL}/demandOperate/manage/getOperationsById`, params)
      }
    }
  }
}
